"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginUrls = void 0;
var SignInUrlBuilder_1 = require("./SignInUrlBuilder");
var LoginUrls = /** @class */ (function () {
    function LoginUrls(queryString) {
        if (queryString && queryString.length > 0) {
            // Prepend a '?' if missing
            queryString = (queryString[0] === '?' ? '' : '?') + queryString;
        }
        else {
            queryString = '';
        }
        this.prefix = '/' + queryString + '#';
    }
    // The full url is prefixed by the query string and puts the path in the hash.
    LoginUrls.prototype.fullUrl = function (path) {
        return this.prefix + path;
    };
    LoginUrls.prototype.signinUrl = function (queryParams) {
        var query = SignInUrlBuilder_1.SignInUrlBuilder.buildQuery(queryParams);
        return this.fullUrl(LoginUrls.signinPart()) + (query ? "?".concat(query) : '');
    };
    LoginUrls.prototype.signinPath = function () {
        return LoginUrls.signinPart();
    };
    LoginUrls.signinPart = function () {
        return '/signin';
    };
    LoginUrls.prototype.siteUrl = function (queryParams) {
        var query = SignInUrlBuilder_1.SignInUrlBuilder.buildQuery(queryParams);
        return this.fullUrl(this.sitePath()) + (query ? "?".concat(query) : '');
    };
    LoginUrls.prototype.sitePath = function () {
        return LoginUrls.sitePart();
    };
    LoginUrls.sitePart = function () {
        return '/site';
    };
    LoginUrls.errorPart = function () {
        return '/error';
    };
    LoginUrls.prototype.loginErrorPath = function () {
        return LoginUrls.errorPart();
    };
    LoginUrls.prototype.signinAuthErorrUrl = function (errorCode, redirectPath) {
        if (redirectPath === void 0) { redirectPath = ''; }
        return this.fullUrl(this.signinAuthErorrPath(errorCode, redirectPath));
    };
    LoginUrls.prototype.signinAuthErorrPath = function (errorCode, redirectPath) {
        if (redirectPath === void 0) { redirectPath = ''; }
        return LoginUrls.errorPart() + LoginUrls.signinPart() + "/".concat(errorCode)
            + (redirectPath ? "?".concat(LoginUrls.redirectPathQueryKey(), "=").concat(encodeURIComponent(redirectPath)) : '');
    };
    LoginUrls.redirectPathQueryKey = function () {
        return 'redirectPath';
    };
    LoginUrls.prototype.signinErorrCodeFromSiteSwitchUrl = function (errorCode) {
        return this.fullUrl(this.signinErorrCodeFromSiteSwitchPath(errorCode));
    };
    LoginUrls.prototype.signinErorrCodeFromSiteSwitchPath = function (errorCode) {
        return this.signinErorrCodePath(errorCode) + "?".concat(LoginUrls.fromSiteSwitchQueryKey(), "=yes");
    };
    LoginUrls.fromSiteSwitchQueryKey = function () {
        return 'fromSiteSwitch';
    };
    LoginUrls.prototype.signinErorrCodeUrl = function (errorCode) {
        return this.fullUrl(this.signinErorrCodePath(errorCode));
    };
    LoginUrls.prototype.signinErorrCodePath = function (errorCode) {
        return LoginUrls.errorPart() + "/".concat(errorCode);
    };
    LoginUrls.prototype.signedOutUrl = function () {
        return this.fullUrl(this.signedOutPath());
    };
    LoginUrls.prototype.signedOutPath = function () {
        return '/signedOut';
    };
    LoginUrls.prototype.siteSamlSignedOutUrl = function () {
        return this.fullUrl(this.siteSamlSignedOutPath());
    };
    LoginUrls.prototype.siteSamlSignedOutPath = function () {
        return '/siteSamlSignedOut';
    };
    LoginUrls.prototype.requestPasswordResetUrl = function () {
        return this.fullUrl(this.requestPasswordResetPath());
    };
    LoginUrls.prototype.requestPasswordResetPath = function () {
        return '/requestPasswordReset';
    };
    LoginUrls.prototype.passwordResetWithTokenUrl = function (token) {
        return this.fullUrl(this.passwordResetWithTokenPath(token));
    };
    LoginUrls.prototype.passwordResetWithTokenPath = function (token) {
        return LoginUrls.resetPasswordPart() + '/' + token;
    };
    LoginUrls.prototype.passwordResetWithUsernameUrl = function (username) {
        return this.fullUrl(this.passwordResetWithUsernamePath(username));
    };
    LoginUrls.prototype.passwordResetWithUsernamePath = function (username) {
        return LoginUrls.resetPasswordPart() + '/?' + LoginUrls.usernameQueryKey() + '=' + username;
    };
    LoginUrls.usernameQueryKey = function () {
        return 'username';
    };
    LoginUrls.resetPasswordPart = function () {
        return '/resetPassword';
    };
    LoginUrls.prototype.passwordResetUserNameBasePath = function () {
        return LoginUrls.resetPasswordPart() + '/';
    };
    return LoginUrls;
}());
exports.LoginUrls = LoginUrls;
//# sourceMappingURL=LoginUrls.js.map